export const ROLES = {
  UBERADMIN: "Uberadmin",
  EDITOR: "Editor",
  VIEWER: "Viewer",
} as const;

export const CMS_ALLOWED_ROLES = [ROLES.UBERADMIN, ROLES.EDITOR] as const;

export const getUserRole = (user?: any): string | null => {
  if (!user) return null;
  if (Array.isArray(user.role)) return user.role[0] || null;
  if (typeof user.role === "string" && user.role) return user.role;
  return user.groups?.[0]?.role || null;
};

export const isUberadmin = (user?: any) => getUserRole(user) === ROLES.UBERADMIN;

export const isEditor = (user?: any) => getUserRole(user) === ROLES.EDITOR;

export const isViewer = (user?: any) => getUserRole(user) === ROLES.VIEWER;

export const canAccessCms = (user?: any) => {
  const role = getUserRole(user);
  return role === ROLES.UBERADMIN || role === ROLES.EDITOR;
};

const ROLE_LABELS: Record<string, string> = {
  uberadmin: "Admin",
  editor: "Editor",
  viewer: "Viewer",
};

export const formatRoleLabel = (role?: string | null) => {
  if (!role) return null;
  return ROLE_LABELS[role.toLowerCase()] || role;
};

export const getUserRoleLabel = (user?: any) => formatRoleLabel(getUserRole(user));

